var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body border rounded mb-4",class:_vm.theme == 'light' ? 'bg-white' : 'border-info'},[_c('div',{staticClass:"card-title mb-2 d-flex justify-content-between"},[_c('h5',{},[_vm._v(" "+_vm._s(_vm.$t("dashboards.top-malware"))+" "),_c('br'),_c('span',{staticClass:"text-info"},[_vm._v("25 "+_vm._s(_vm.$t("dashboards.day")))])]),_c('div',[_c('b-button',{staticClass:"mr-2",attrs:{"variant":_vm.charttype == 'line' ? 'primary' : 'outline-primary',"size":"sm","title":"Line Chart"},on:{"click":function($event){return _vm.changeType('line')}}},[_c('i',{staticClass:"bx bxs-chart font-size-24 align-middle"})]),_c('b-button',{attrs:{"variant":_vm.charttype == 'bar' ? 'primary' : 'outline-primary',"size":"sm","title":"Bar Chart"},on:{"click":function($event){return _vm.changeType('bar')}}},[_c('i',{staticClass:"bx bxs-bar-chart-square font-size-24 align-middle"})])],1)]),(_vm.loading.top)?_c('div',[_vm._m(0)]):_vm._e(),(!_vm.loading.top && _vm.series[0])?_c('div',[_c('apexchart',{staticClass:"apex-charts",attrs:{"type":_vm.charttype,"dir":"ltr","height":"440","series":_vm.series,"options":{
        legend: {
          show: true,
          showForSingleSeries: false,
          showForNullSeries: true,
          showForZeroSeries: true,
          position: 'bottom',
          horizontalAlign: 'center',
          floating: false,
          fontSize: '14px',
          fontFamily: 'Helvetica, Arial',
          fontWeight: 400,
          formatter: undefined,
          inverseOrder: false,
          width: undefined,
          height: undefined,
          tooltipHoverFormatter: undefined,
          customLegendItems: [],
          offsetX: 0,
          offsetY: 0,
          labels: {
            colors: '#fff',
            useSeriesColors: false,
          },
          markers: {
            width: 12,
            height: 12,
            strokeWidth: 0,
            strokeColor: '#fff',
            fillColors: undefined,
            radius: 12,
            customHTML: undefined,
            onClick: undefined,
            offsetX: 0,
            offsetY: 0,
          },
          itemMargin: {
            horizontal: 5,
            vertical: 4,
          },
          onItemClick: {
            toggleDataSeries: true,
          },
          onItemHover: {
            highlightDataSeries: true,
          },
        },
        chart: {
          zoom: {
            enabled: true,
          },
          toolbar: {
            show: true,
          },
          redrawOnParentResize: true,
        },
        colors: ['#E2A040', '#53A9DA', '#E7515A', '#009688'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: [2, 2, 2],
        },
        title: {
          text: 'Daily Comulative Report',
          align: 'left',
        },
        markers: {
          size: 0,

          hover: {
            sizeOffset: 6,
          },
        },
        xaxis: {
          categories: _vm.days,
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return val.toFixed(0);
            },
          },
        },
        grid: {
          show: true,
          strokeDashArray: 0.3,
          borderColor: '#000', // you can either change hear to disable all grids
          xaxis: {
            lines: {
              show: false, //or just here to disable only x axis grids
            },
          },
          yaxis: {
            lines: {
              show: true, //or just here to disable only y axis
            },
          },
        },

        chart: {
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
          redrawOnParentResize: true,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '70%',
            endingShape: 'rounded',
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: _vm.days,
        },
        colors: [
          '#84cc16',
          '#3b82f6',
          '#6f42c1',
          '#e83e8c',
          '#E7515A',
          '#e95f2b',
          '#14b8a6',
          '#e2a03f',
          '#009688',
          '#53A9DA',
          '#ef4444',
          '#8b5cf6' ],
      }}})],1):_vm._e(),(!_vm.loading.recap && !_vm.series[0])?_c('div',[_c('div',{staticClass:"m-5 p-5"},[_c('div',{staticClass:"text-center py-4 my-5"},[_c('span',{staticClass:"py-5 my-5"},[_vm._v(" "+_vm._s(_vm.$t("dashboards.data-not-found")))])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-4 my-5"},[_c('i',{staticClass:"bx bx-loader-circle bx-spin bx-md"}),_vm._v(" "),_c('br'),_c('span',{staticClass:"font-size-16"},[_vm._v(" Loading ... ")])])}]

export { render, staticRenderFns }